import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Select from "react-select";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

// Flattened helper arrays
const CURRENCY_OPTIONS = [
  { value: "", label: "Select" },
  { value: "USD", label: "USD" },
  { value: "ZIG", label: "ZIG" },
];

const ACTIVE_STATUS_OPTIONS = [
  { value: "", label: "Select" },
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];

export default class BundleSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,valid:false,
      msg: "",
      toastColor: "",
      bundles: [],
      bundle: {
        id: 0,
        name: "",
        cost: 0,
        credits: 0,
        currency: "USD",
        expiryInDays: 0,
        activeStatus: "YES",
      },
      editing: false,
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchBundles = this.fetchBundles.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    this.fetchBundles(token);
  }

  fetchBundles(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/billing/getallbundles", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const bundles = Array.isArray(response.data) ? response.data : [];
        this.setState({
          bundles: bundles,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          bundles: [],
          loading: false,
          msg: error?.response?.data?.message || "Failed to load bundles.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    let newValue = value;
    if (name === "cost" || name === "credits" || name === "expiryInDays") {
      newValue = parseFloat(value) || 0;
    }
    this.setState(
      (prevState) => ({
        bundle: { ...prevState.bundle, [name]: newValue },
      }),
      this.validate
    );
  }

  handleSelect(name, selectedOption) {
    const value = selectedOption ? selectedOption.value : "";
    this.setState(
      (prevState) => ({
        bundle: { ...prevState.bundle, [name]: value },
      }),
      this.validate
    );
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (this.state.editing) {
      // Explicit validation like in registration examples
      if (!s.bundle.name || s.bundle.name.trim() === "") {
        errors.name = "Name is required";
        valid = false;
      }
      if (!s.bundle.cost || s.bundle.cost <= 0) {
        errors.cost = "Cost must be greater than 0";
        valid = false;
      }
      if (!s.bundle.credits || s.bundle.credits <= 0) {
        errors.credits = "Credits must be greater than 0";
        valid = false;
      }
      if (!s.bundle.currency || s.bundle.currency.trim() === "") {
        errors.currency = "Currency is required";
        valid = false;
      }
      if (!s.bundle.expiryInDays || s.bundle.expiryInDays <= 0) {
        errors.expiryInDays = "Expiry days must be greater than 0";
        valid = false;
      }
      if (!s.bundle.activeStatus || s.bundle.activeStatus.trim() === "") {
        errors.activeStatus = "Active status is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = { ...this.state.bundle };

    const self = this;
    axios
      .post(API + "/billing/bundlesave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Bundle saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            bundle: {
              id: 0,
              name: "",
              cost: 0,
              credits: 0,
              currency: "USD",
              expiryInDays: 0,
              activeStatus: "YES",
            },
            editing: false,
            errors: {},
          });
          // Refetch data
          self.fetchBundles(token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save bundle.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save bundle. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(bundle) {
    this.setState(
      {
        bundle: { ...bundle },
        editing: true,
      },
      this.validate
    );
  }

  handleCancelEdit() {
    this.setState({
      bundle: {
        id: 0,
        name: "",
        cost: 0,
        credits: 0,
        currency: "USD",
        expiryInDays: 0,
        activeStatus: "YES",
      },
      editing: false,
      errors: {},
    });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="Bundle Settings" />
          {divMsg}
          <div className="w-full grow px-5 h-[60%]">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="flex flex-col items-center w-full mt-2 pt-3 pb-2 h-full overflow-y-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="grid grid-cols-2 gap-x-8 gap-y-4 max-w-5xl mx-auto">
                  <div className="input-group">
                    <label className="input-group-text">Name</label>
                    <input
                      name="name"
                      className={`form-control ${
                        s.errors.name ? " !border-red-500" : ""
                      }`}
                      value={s.bundle.name}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.name && (
                      <span className="input-group-error">{s.errors.name}</span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Cost</label>
                    <input
                      name="cost"
                      type="number"
                      min="1"
                      className={`form-control ${
                        s.errors.cost ? " !border-red-500" : ""
                      }`}
                      value={s.bundle.cost}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.cost && (
                      <span className="input-group-error">{s.errors.cost}</span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Credits</label>
                    <input
                      name="credits"
                      type="number"
                      min="1"
                      className={`form-control ${
                        s.errors.credits ? " !border-red-500" : ""
                      }`}
                      value={s.bundle.credits}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.credits && (
                      <span className="input-group-error">
                        {s.errors.credits}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Currency</label>
                    <Select
                      name="currency"
                      value={CURRENCY_OPTIONS.find(
                        (currency) => currency.value === s.bundle.currency
                      )}
                      onChange={(e) => this.handleSelect("currency", e)}
                      className={`form-control ${
                        s.errors.currency ? " !border-red-500" : ""
                      }`}
                      required
                      options={CURRENCY_OPTIONS}
                    />
                    {s.errors.currency && (
                      <span className="input-group-error">
                        {s.errors.currency}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Expiry Days</label>
                    <input
                      name="expiryInDays"
                      type="number"
                      min="1"
                      className={`form-control ${
                        s.errors.expiryInDays ? " !border-red-500" : ""
                      }`}
                      value={s.bundle.expiryInDays}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.expiryInDays && (
                      <span className="input-group-error">
                        {s.errors.expiryInDays}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <Select
                      name="activeStatus"
                      value={ACTIVE_STATUS_OPTIONS.find(
                        (status) => status.value === s.bundle.activeStatus
                      )}
                      onChange={(e) => this.handleSelect("activeStatus", e)}
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      required
                      options={ACTIVE_STATUS_OPTIONS}
                    />
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex justify-center gap-8 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-success">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="flex gap-2 mb-2 items-baseline justify-between">
                  <h3 className="font-bold">Configured Bundles</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit({})}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.bundles.length === 0 ? (
                  <div className="text-gray-500">No bundles found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50 sticky top-0">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Cost
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Credits
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Currency
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Expiry (days)
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {s.bundles.map((bundle, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {bundle.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {bundle.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {bundle.cost}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {bundle.credits}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {bundle.currency}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {bundle.expiryInDays}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {bundle.activeStatus}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <button
                                className="btn btn-success"
                                onClick={() => this.handleEdit(bundle)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
